<template>
  <div>
    <form :action="fullUrl" method="post" id="gopay-payment-button">
      <button name="pay" type="submit" class="Btn -Primary -WidthFixed">
        <slot>Zaplatit <aw-icon icon="arrow-right" class="ml-auto w-7 h-7" /></slot>
      </button>
    </form>
  </div>
</template>

<script>
// https://help.gopay.com/cs/tema/integrace-platebni-brany/technicky-popis-integrace-platebni-brany/postup-integrace-platebni-brany
// TEST:  <script type="text/javascript" src="https://gw.sandbox.gopay.com/gp-gw/js/embed.js">
// PROD: <script type="text/javascript" src="https://gate.gopay.cz/gp-gw/js/embed.js">

const DEVELOPMENT_URL = 'https://gw.sandbox.gopay.com/gp-gw/js/embed.js'
const PRODUCTION_URL = 'https://gate.gopay.cz/gp-gw/js/embed.js'

import { loadScript } from '../TransportChoices/helpers/loadScript'
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    productionMode: {
      type: Boolean,
      required: true
    },
    autoRun: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    fullUrl() {
      return this.url
    }
  },
  async mounted() {
    await loadScript(this.productionMode ? PRODUCTION_URL : DEVELOPMENT_URL, 'gopayInlineForm')
    if (this.autoRun) {
      console.log('LOG AUTORUN?')
      window._gopay.checkout({ gatewayUrl: this.fullUrl, inline: true })
    }
  }
}
</script>

<style lang="scss" scoped></style>
